import { axiosPrivate } from "api/axios";
import Cookies from "js-cookie";
import { AUTH_TOKEN } from "constants/AuthConstant";

const PartnerService = {};

const getHeaders = (data) => {
  const isFormData =
    typeof FormData !== "undefined" && data instanceof FormData;
  return {
    Authorization: `Bearer ${Cookies.get(AUTH_TOKEN)}`,
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  };
};

PartnerService.getPartners = function (page = 1, limit = 10, search) {
  const params = { page, limit };
  if (search) {
    params.search = search;
  }
  return axiosPrivate({
    method: "get",
    url: "/partners/admin/All",
    params,
    headers: getHeaders(),
  });
};

PartnerService.getPartner = function (id) {
  return axiosPrivate({
    method: "get",
    url: `/partners/${id}/admin`,
    headers: getHeaders(),
  });
};

PartnerService.updatePartner = function (id, data) {
  return axiosPrivate({
    method: "put",
    url: `/partners/${id}/admin`,
    data,
    headers: getHeaders(data),
  });
};

PartnerService.updatePartnerStatus = function (id, body) {
  return axiosPrivate({
    method: "put",
    url: `/partners/${id}/status/admin`,
    data: body,
    headers: getHeaders(),
  });
};

PartnerService.confirmPartnerPayment = function (id, body) {
  return axiosPrivate({
    method: "post",
    url: `/partners/${id}/admin/confirm-payment`,
    data: body,
    headers: getHeaders(),
  });
};

PartnerService.deletePartner = function (id) {
  return axiosPrivate({
    method: "delete",
    url: `/partners/${id}/admin`,
    headers: getHeaders(),
  });
};

PartnerService.createPartner = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/partners/register",
    data,
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export default PartnerService;
